import React from "react";
import { useSubheader } from "../../../../_metronic/layout";

export const CostsPage = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Costi");

    return (<></>);
};
